/**
 * @flow
 * @relayHash db41827f26f34396eee6df6b2655b018
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
export type POUploadStatus = "CONFIRMED" | "FAILED" | "PROCESSING" | "READY_FOR_REVIEW";
export type ConfirmPOExtractionInput = {|
  poUploadId: string,
  matchedData: any,
|};
export type ConfirmPOExtractionMutationVariables = {|
  input: ConfirmPOExtractionInput
|};
export type ConfirmPOExtractionMutationResponse = {|
  +confirmPOExtraction: {|
    +poUpload: {|
      +poUploadId: string,
      +status: POUploadStatus,
      +orderId: ?string,
    |},
    +orderEdge: {|
      +node: {|
        +id: string
      |}
    |},
  |}
|};
export type ConfirmPOExtractionMutation = {|
  variables: ConfirmPOExtractionMutationVariables,
  response: ConfirmPOExtractionMutationResponse,
|};
*/


/*
mutation ConfirmPOExtractionMutation(
  $input: ConfirmPOExtractionInput!
) {
  confirmPOExtraction(input: $input) {
    poUpload {
      poUploadId
      status
      orderId
    }
    orderEdge {
      node {
        id
      }
    }
  }
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = [
  {
    "kind": "LocalArgument",
    "name": "input",
    "type": "ConfirmPOExtractionInput!",
    "defaultValue": null
  }
],
v1 = [
  {
    "kind": "LinkedField",
    "alias": null,
    "name": "confirmPOExtraction",
    "storageKey": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "ConfirmPOExtractionPayload",
    "plural": false,
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "poUpload",
        "storageKey": null,
        "args": null,
        "concreteType": "POUpload",
        "plural": false,
        "selections": [
          {
            "kind": "ScalarField",
            "alias": null,
            "name": "poUploadId",
            "args": null,
            "storageKey": null
          },
          {
            "kind": "ScalarField",
            "alias": null,
            "name": "status",
            "args": null,
            "storageKey": null
          },
          {
            "kind": "ScalarField",
            "alias": null,
            "name": "orderId",
            "args": null,
            "storageKey": null
          }
        ]
      },
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "orderEdge",
        "storageKey": null,
        "args": null,
        "concreteType": "OrderEdge",
        "plural": false,
        "selections": [
          {
            "kind": "LinkedField",
            "alias": null,
            "name": "node",
            "storageKey": null,
            "args": null,
            "concreteType": "Order",
            "plural": false,
            "selections": [
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "id",
                "args": null,
                "storageKey": null
              }
            ]
          }
        ]
      }
    ]
  }
];
return {
  "kind": "Request",
  "fragment": {
    "kind": "Fragment",
    "name": "ConfirmPOExtractionMutation",
    "type": "Mutation",
    "metadata": null,
    "argumentDefinitions": (v0/*: any*/),
    "selections": (v1/*: any*/)
  },
  "operation": {
    "kind": "Operation",
    "name": "ConfirmPOExtractionMutation",
    "argumentDefinitions": (v0/*: any*/),
    "selections": (v1/*: any*/)
  },
  "params": {
    "operationKind": "mutation",
    "name": "ConfirmPOExtractionMutation",
    "id": null,
    "text": "mutation ConfirmPOExtractionMutation(\n  $input: ConfirmPOExtractionInput!\n) {\n  confirmPOExtraction(input: $input) {\n    poUpload {\n      poUploadId\n      status\n      orderId\n    }\n    orderEdge {\n      node {\n        id\n      }\n    }\n  }\n}\n",
    "metadata": {}
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = 'b36c435617b0382463a772ba15c7b02d';
module.exports = node;
